// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Fallback values - these are PUBLIC anon keys, safe to include in client code
// Security relies on RLS policies, not on hiding these keys
const FALLBACK_URL = 'https://vsstvjkmkmqejrvxklhn.supabase.co';
const FALLBACK_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZzc3R2amtta21xZWpydnhrbGhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4NjAwMDMsImV4cCI6MjA2OTQzNjAwM30.VtZtH3HjGEGmi9fTIY-4Z5edAp93kjsVF1rUb_L2Uek';

// Use environment variables with safe fallbacks (never throw before React mounts)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || FALLBACK_URL;
const SUPABASE_PUBLISHABLE_KEY = 
  import.meta.env.VITE_SUPABASE_ANON_KEY 
  || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY 
  || FALLBACK_KEY;

// Log warning in development if using fallbacks
if (import.meta.env.DEV && (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY)) {
  console.warn('[Supabase] Using fallback configuration. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env for explicit configuration.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
